import { YoutubeEmbed } from '@/app/components/YoutubeEmbed'
import { ICourse } from '@/types/course'

type CourseVideoProps = Pick<ICourse, 'videoUrl'> &
  Pick<React.HTMLAttributes<HTMLDivElement>, 'className' | 'id'>

export function CourseVideo({ videoUrl, ...props }: CourseVideoProps) {
  if (!videoUrl) {
    return null
  }

  const youtubeId =
    /(youtu\.be\/|youtube\.com\/(watch\?(.*&)?v=|(embed|v)\/))([^\?&"'>]+)/.exec(
      videoUrl
    )?.[5] ?? ''

  return youtubeId ? (
    <YoutubeEmbed {...props} embedId={youtubeId} />
  ) : (
    <video {...props} controls poster="">
      <source src={videoUrl} />
    </video>
  )
}
